import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  formatCurrency,
  copy,
  getSinglarOrPluralWord,
  formatDateTime,
  getTimezoneDate,
  formatNumber,
} from "../../../utilities/helpers";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { InfoIcon } from "../../InfoIcon";

import placeholder from "../../../assets/placeholder.png";

import "./cards.scss";

export default function Cards({
  flexPack,
  isDisabled,
  hasFlexPackEnded,
  isVisible,
  handleChange,
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  return (
    <section className="cards">
      <Row>
        <Col xs={8} className="col-1">
          <Row>
            <Col>
              <Stack gap={4}>
                <Card body className="card--light">
                  <div className="card-body-heading--sm">
                    <Card.Title as="h5" className="card-title-upper">
                      Overview
                    </Card.Title>
                  </div>
                  <Row id="overview-box">
                    <Col>
                      <div className="card-body-heading heading--flex sold m-0">
                        <Stack>
                          <Stack
                            direction="horizontal"
                            className="small-label--flex"
                          >
                            <span className="small-label">
                              Flex packages sold
                            </span>
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip>Number of flex packages sold.</Tooltip>
                              }
                            >
                              <Button variant="link">
                                <InfoIcon variant="dark" />
                              </Button>
                            </OverlayTrigger>
                          </Stack>
                          <h5 className="card-title card-title-xl">
                            {formatNumber(flexPack?.flexPacksSold)}
                          </h5>
                        </Stack>
                      </div>
                    </Col>
                    <Col>
                      <Stack gap={1} className="price">
                        <span className="small small-bold">Price</span>
                        <span className="fw-semibold">
                          {formatCurrency(flexPack?.price)}
                        </span>
                      </Stack>
                    </Col>
                  </Row>
                </Card>
              </Stack>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="card--md-vertical card--light">
                <Card.Body className="d-flex-column">
                  <div className="card-body-heading--xs">
                    <Card.Title as="h5" className="card-title-upper">
                      Flex Package Listing
                    </Card.Title>
                    <Card.Subtitle
                      as="h6"
                      className="subtitle--dark mt-2 fw-medium"
                    >
                      Your flex package listing is now available
                    </Card.Subtitle>
                  </div>
                  <Stack
                    direction="horizontal"
                    className="mt-auto justify-content-start btn-group-flex btn-group-flex-sm"
                  >
                    <Button
                      variant="outline-light"
                      className={`copy-link-btn btn-width-xs--flex-item ${copied ? "btn-copy--success" : ""} `}
                      onClick={() =>
                        copy(
                          `${process.env.REACT_APP_CONSUMER_PORTAL}/venue/${flexPack?.venue?.slug}/flex-pack/${flexPack?.uuid}`,
                          setCopied,
                        )
                      }
                      disabled={isDisabled}
                    >
                      {!copied && "Copy link"}
                    </Button>
                    <Link
                      to={`${process.env.REACT_APP_CONSUMER_PORTAL}/venue/${flexPack?.venue?.slug}/flex-pack/${flexPack?.uuid}`}
                      target="_blank"
                      className={`btn btn-primary ${isDisabled ? "btn-link-disabled" : ""}`}
                    >
                      Open flex package page
                    </Link>
                  </Stack>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col xs={4} className="d-flex col-2">
          <Card className="card--md card--light">
            <Card.Body className="d-flex-column">
              <div className="card-body-heading--sm">
                <Card.Title as="h5" className="card-title-upper">
                  Flex Package Details
                </Card.Title>
              </div>
              <Card.Img
                src={flexPack?.image?.url || placeholder}
                width="332"
                height="145"
                alt={`Cover art for ${flexPack?.name} flex package`}
                className="event-image package-img mb-3"
              />
              <h4 className="name fs-md fs-md-bold">{flexPack?.name}</h4>
              <span className="normal normal-bold">
                {formatNumber(flexPack?.gameTickets)}{" "}
                {getSinglarOrPluralWord(flexPack?.gameTickets, "Voucher")}
              </span>
              <span className="subtitle fw-medium">
                <span>
                  {formatDateTime(
                    getTimezoneDate(flexPack?.start, flexPack?.timezone),
                    "dateOnly",
                  )}
                </span>
                <span className="to">
                  {formatDateTime(
                    getTimezoneDate(flexPack?.end, flexPack?.timezone),
                    "dateOnly",
                  )}
                </span>
              </span>
              <Link
                to="flex-package-details"
                className="small small-bold link-goTo my-3"
              >
                Manage details
              </Link>
              <Card
                body
                id="visibility-card"
                className="card--sm card-with-border h-auto mt-auto"
              >
                <Form.Check
                  type="switch"
                  id="flex-pack-visibility"
                  label="Visibility"
                  checked={isVisible}
                  onChange={(e) => {
                    handleChange(e, e.target.checked);
                  }}
                  disabled={isDisabled}
                  className="form-switch--with-desc gap-lg"
                />
                <small className="subtitle subtitle--dark form-switch--with-desc-subtitle gap-lg">
                  Flex package will be visible to attendees
                </small>
              </Card>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
}
